import React from "react";
import ConfigSection from "../../ConfigSection";

const ContractDurationSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Contract Duration'
      configType='ContractDuration'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default ContractDurationSection;
